import { TableBody, TableCell, TableRow } from "@gfg/ui/components/table";
import { createUseStyles } from "@gfg/ui/theming";
import { Link, useParams } from "react-router-dom";

import SuccessStatusTag from "common/components/status-tags/success-tag";
import GrayStatusTag from "common/components/status-tags/gray-tag";
import { SearchOptimizationStateTranslations } from "common/translations";
import { SearchOptimization, SearchOptimizationState } from "@coral/typings";
import TitleSubtitleCell from "../../../common/components/table/cells/title-subtitle-cell";
import date from "../../../common/services/dates";
import ActionCell from "./action-cell";

interface OptimizationsListProps {
  optimizations: SearchOptimization[] | null;
  onEditOptimization(optimization: SearchOptimization): void;
  onRemoveOptimization(optimization: SearchOptimization): void;
  onOptimizationStateChange(optimization: SearchOptimization, newState: SearchOptimizationState): void;
}

const useStyles = createUseStyles(({ colors, spacing, breakpoints }) => ({
  rowGrey: {
    background: colors.lightergray,
  },
  rowLight: {
    background: colors.white,
  },
  limitedCell: {
    maxWidth: 240,
    paddingRight: spacing(38),

    [breakpoints.down("md")]: {
      maxWidth: "initial",
      paddingRight: 0,
    },
  },
  iconButton: {
    height: 0,
    paddingLeft: 0,
  },
}));

export default function OptimizationsList({
  optimizations,
  onEditOptimization,
  onRemoveOptimization,
  onOptimizationStateChange,
}: OptimizationsListProps) {
  const classes = useStyles();
  const { region } = useParams();

  const createStatusTag = (optimization: SearchOptimization) =>
    optimization.state === "Enabled" ? (
      <SuccessStatusTag label={SearchOptimizationStateTranslations[optimization.state]} />
    ) : (
      <GrayStatusTag label={SearchOptimizationStateTranslations[optimization.state]} />
    );

  return (
    <TableBody className="tableBody">
      {optimizations?.map((optimization, index) => (
        <TableRow key={optimization.id} className={index % 2 === 0 ? classes.rowGrey : classes.rowLight}>
          <TitleSubtitleCell
            title={<Link to={`/${region}/search/optimizations/edit/${optimization.id}`}>{optimization.query}</Link>}
          />
          <TitleSubtitleCell title={optimization.output} />
          <TitleSubtitleCell
            title="Last Modified"
            subtitle={optimization.updatedAt && date.format(optimization.updatedAt)}
          />
          <TableCell>
            <div>
              <span>{createStatusTag(optimization)}</span>
            </div>
          </TableCell>

          <ActionCell
            onDelete={() => onRemoveOptimization(optimization)}
            onEdit={() => onEditOptimization(optimization)}
            onStateChange={newState => onOptimizationStateChange(optimization, newState)}
          />
        </TableRow>
      ))}
    </TableBody>
  );
}
